export const USER_UPDATED="userUpdated"
export const USER_SIGNOUT="userSignOut"
export const NOTES_UPDATED="notesUpdated"
export const KINDLE_QUOTES_UPDATED="kindleQuotesUpdated"
export const VOCAB_STORE_AVAILABLE="vocabStoreAvailable"